import he from "he";

export const decodeHTMLEntities = (text) => he.decode(text);
